module.exports = __webpack_public_path__ + "img/s_5.e6499d0b.png";